import React from 'react';
import EcoAssociationClass3to5 from 'views/EcoAssociationClass3to5';

const AccountGeneralPage = () => {
  return <EcoAssociationClass3to5/>;
};

export default AccountGeneralPage;